import { accountApi } from "../api/accountApi";

export const verificationCodeEnpoints = accountApi.injectEndpoints({
  endpoints: (build) => ({
    updateCurrentUser: build.mutation({
      query: (args) => {
        return {
          method: "PUT",
          body: args,
          url: `users/current`,
        };
      },
      invalidatesTags: [],
    }),
    validateVerificationCode: build.mutation({
      query: (body) => ({
        method: "POST",
        body,
        url: `verificationCodes/validate`,
      }),
      invalidatesTags: ["verificationCodes"],
    }),
    createAccessToken: build.mutation({
      query: (body) => ({
        method: "POST",
        body,
        url: `users/current/accessTokens`,
      }),
      invalidatesTags: [],
    }),
    updateUserPassword: build.mutation<void, { body: { password: string } }>({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `users/current/password`,
      }),
    }),
  }),
});

export const {
  useValidateVerificationCodeMutation,
  useUpdateCurrentUserMutation,
  useUpdateUserPasswordMutation,
  useCreateAccessTokenMutation,
} = verificationCodeEnpoints;

export default verificationCodeEnpoints;
